import { render } from "./ui-rangeslider.vue?vue&type=template&id=5b9aaae2"
import script from "./ui-rangeslider.vue?vue&type=script&lang=js"
export * from "./ui-rangeslider.vue?vue&type=script&lang=js"

import "./ui-rangeslider.vue?vue&type=style&index=0&id=5b9aaae2&lang=css"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__